import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ConnectUrlResponse, YoutubeAccountDto } from '../models/api.models';
import { DisconnectResponse } from '../models/disconnect.model';

@Injectable({
  providedIn: 'root'
})
export class YoutubeService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getConnectUrl(): Observable<string> {
    return this.http.get<ConnectUrlResponse | string>(`${this.baseUrl}/youtube/connect`).pipe(
      map(res => (typeof res === 'string' ? res : res?.authorizationUrl))
    );
  }

  handleCallback(code: string): Observable<YoutubeAccountDto> {
    return this.http.get<YoutubeAccountDto>(`${this.baseUrl}/youtube/callback`, { params: { code } });
  }

  disconnect(): Observable<DisconnectResponse> {
    return this.http.post<DisconnectResponse>(`${this.baseUrl}/youtube/disconnect`, {});
  }
}
